<app-medshorts-pharmacy-info *ngIf="isMedshorts"></app-medshorts-pharmacy-info>
<app-outsourcing-pharmacy-info
  *ngIf="isOutsourcing"
></app-outsourcing-pharmacy-info>
<app-medigi-pharamacy-info *ngIf="isMedigi"></app-medigi-pharamacy-info>
